import { VideoCallDaily } from '@/components/video/VideoCallDaily';

export const SingleVideo = () => {
	return <VideoCallDaily />;
};
